import React from 'react'

const FlyerOnWall = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/flyer_on_wall.svg" alt="flyer_on_wall"/>
  )
}

export default FlyerOnWall